import * as React from "react";
import { memo } from "react";
const SvgSubmissionBackground = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 379, height: 56, viewBox: "0 0 379 56", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M379 8.89412L371.806 1.66644L4.52625 0L0 44.6644L12.4502 56L371.806 52.8028L379 8.89412Z", fill: "#011022" }));
const Memo = memo(SvgSubmissionBackground);
export default Memo;
